import { mapState } from "vuex";
import Tinymce from "@/components/tinymce";

export default {
  components: {
    Tinymce,
  },
  data() {
    return {
      TinymceMain: "",
      contentInit: {},
      activityId: "",
      origin: process.env,

      content: null,
      areaValue: [],
      date: [],
      goodsPriceList: [], // 阶梯设置的list
      goodPriceVisible: false,
      priceIndex: 0,
      chooseGoodVisible: false,
      searchName: "",

      pageSize: 10, // 商品列表页分页大小
      currentPage: 1, // 商品列表页当前分页
      totalCount: 0, // 商品列表页商品总数
      goodsDataList: [], // 店铺商品列表
      goodsSelectList: [], // 店铺商品选中列表
      checkGoodsList: [], // 选择的商品
      checkDtlList: [],
      activity: {
        id: "",
        name: "",
        activityGoodsReqFormList: [],
        activityDtlReqFormList: [],
      },
      searchGoods: {
        name: "",
        axis: "",
        pageNum: 1,
        pageSize: 10,
        isoa: 0,
        status: "5",
        isGroup: 1,
        isVip: 0,
      },

      isEdit: false,
      timeout: setTimeout(() => ({}), 500),
      activityUsed: false,
      isChanged: false,
    };
  },
  computed: mapState({
    isReload: (state) => state.app.isReload,
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    if (this.isReload) {
      window.location.reload();
      this.$store.commit("app/setIsReload", false);
    }
    const { id, isEnd } = this.$route.query;
    this.activityId = id || "";
    this.activity.id = id || "";
    this.isEnd = isEnd || "";

    // this.listShopGoods(); // 获取商品
    if (id) {
      this.getDetail();
    }
  },
  // 进入页面加载数据 -相当于jquery的ready
  mounted() {},
  // 监听器
  filters: {},
  methods: {
    // 点击添加货品
    selectGoodsList() {
      this.searchName = "";
      this.listShopGoods();
    },

    // 点击添加答疑
    addGoodsDy() {
      let item = {
        question: "",
        answer: "",
        personAmount: "",
        top: false,
        show: false,
      };
      this.checkDtlList.unshift(item);
      this.hadChange();
    },

    goodSearch() {
      this.listShopGoods();
    },

    // 查询活动商品
    listShopGoods() {
      const { searchName } = this;
      this.$store
        .dispatch("goodsDy/getGoodsSpu", {
          status: 5,
          name: searchName,
          queryType: "DY",
          current: 1,
          size: 500,
        })
        .then((res) => {
          console.log("活动商品", res);
          const goodsList = res.data.records || [];
          this.goodsDataList = goodsList.map((item) => {
            return {
              ...item,
            };
          });

          // 选中
          this.checkedHad();
        });
    },

    // 选中
    checkedHad() {
      const { goodsDataList, checkGoodsList } = this;
      this.chooseGoodVisible = true;
      this.$nextTick(() => {
        goodsDataList.forEach((row) => {
          if (checkGoodsList.some((item2) => row.spuId == item2.spuId)) {
            this.$refs.multipleTable.toggleRowSelection(row, true);
          }
        });
      });
    },

    // 确定选择商品
    goodsDialogConfirm() {
      const goodList = [];
      this.goodsSelectList.forEach((item) => {
        if (this.checkGoodsList.some((item2) => item.spuId == String(item2.spuId))) {
          this.checkGoodsList.forEach((item1) => {
            if (item.spuId == String(item1.spuId)) {
              goodList.push(item1);
            }
          });
        } else {
          goodList.push(item);
        }
      });
      this.checkGoodsList = goodList;
      this.goodsDialogCancel();
      console.log("goodsList: {}", goodList);
      this.hadChange();
    },

    goodsDialogCancel() {
      this.chooseGoodVisible = false;
      this.$refs.multipleTable.clearSelection();
    },
    // 删除已选中商品
    removeCheckGoods(index) {
      this.checkGoodsList.splice(index, 1);
      this.hadChange();
    },

    handleSelectionChange(selection) {
      this.goodsSelectList = selection;
    },

    selectable(row) {
      if (row.activityUsed) {
        return false;
      }
      return true;
    },

    // 保存
    onSubmit() {
      if (!this.checkGoodsList.length) {
        this.$message.warning("请选择商品");
        return;
      }
      if (!this.checkDtlList.length) {
        this.$message.warning("请添加答疑");
        return;
      }
      const { activity, checkGoodsList, checkDtlList } = this;
      let hadTop = false;
      try {
        checkDtlList.forEach((row) => {
          if (!row.question) {
            this.$message.warning("请输入问题");
            throw new Error("");
          }
          if (!row.answer) {
            this.$message.warning("请输入回答");
            throw new Error("");
          }
          if (row.top == null) {
            this.$message.warning("请选择是否置顶");
            throw new Error("");
          }
          if (row.show == null) {
            this.$message.warning("请选择是否展示");
            throw new Error("");
          }
          if (row.top === true || row.top === "true") {
            hadTop = true;
          }
        });
      } catch (e) {
        console.log("校验");
        return false;
      }

      if (!hadTop) {
        this.$message.warning("请选择精选答疑");
        return;
      }
      this.activityGoodsReqFormList = checkGoodsList.map((item) => {
        const { spuId } = item;
        return {
          ...item,
          id: spuId,
        };
      });

      this.activityDtlReqFormList = checkDtlList.map((item) => {
        let jsSz = [];
        jsSz.push(item);
        return {
          diyInfo: JSON.stringify(jsSz),
        };
      });
      this.activity = {
        ...activity,
        type: "DY",
        activityGoodsReqFormList: this.activityGoodsReqFormList,
        activityDtlReqFormList: this.activityDtlReqFormList,
      };

      // 新增
      if (!this.activity.id) {
        this.$store.dispatch("goodsDy/addCommonActivity", this.activity).then((res) => {
          const msg = this.activity.id ? "编辑成功" : "添加成功";
          if (res.code === "0") {
            this.$message.success(msg);
            this.toList();
          } else {
            this.$message.warning(res.msg);
          }
        });
        return;
      }
      // 修改
      this.$store.dispatch("goodsDy/modifyCommonActivity", this.activity).then((res) => {
        const msg = this.activity.id ? "编辑成功" : "添加成功";
        if (res.code === "0") {
          this.$message.success(msg);
          this.toList();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },

    getDetail() {
      this.$store
        .dispatch("goodsDy/getCommonActivityDtl", {
          id: this.activityId,
          incGoodsInfo: true,
          incLongText: true,
        })
        .then((data) => {
          const activity = data;
          const { activityGoodsResList, activityDtlResList } = activity;
          // 商品
          this.checkGoodsList = activityGoodsResList.map((item) => {
            const { spuName } = item;
            return {
              ...item,
              name: spuName,
            };
          });
          console.log("checkGoodsList: {}", this.checkGoodsList);
          this.checkDtlList = activityDtlResList.map((item) => {
            return {
              ...item.goodsDyDtlRes,
            };
          });
          console.log("checkDtlList: {}", this.checkDtlList);

          this.activity = {
            ...activity,
          };
          console.log("activity", this.activity);
        });
    },
    initDy() {
      if (this.checkDtlList.length == 0) {
        let dtl = {};
        dtl.question = "";
        dtl.answer = "";
        dtl.personAmount = "";
        dtl.top = "";
        dtl.show = "";
        this.checkDtlList.push(dtl);
      }
    },
    doCancel() {
      if (this.isChanged == true) {
        this.$confirm("您确定不保存当前信息并返回么？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }).then(() => {
          this.$router.push("/mj/goodsDy");
        });
      }
      if (this.isChanged == false) {
        this.$router.push("/mj/goodsDy");
      }
    },
    toList() {
      this.$router.push("/mj/goodsDy");
    },
    removeDtl(item) {
      let index = this.checkDtlList.indexOf(item);
      if (index !== -1) {
        this.checkDtlList.splice(index, 1);
      }
      this.hadChange();
    },
    hadChange() {
      this.isChanged = true;
    },
  },
};
